'use strict';

var directives = angular.module('gymsystem.directives', []);

directives.directive('filesSelected', ['$rootScope', '$parse', function ($rootScope, $parse) {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.bind('change', function(){
                scope.$parent.$apply(function(){
                    var callback = $parse(attrs.filesSelected);
                    callback(scope)(element[0].files);
                    $rootScope.setupKeypressListener();
                });
            });
        }
    };
}]);

directives.directive('selectOnClick', [function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            element.on('click', function () {
                this.select();
            });
        }
    };
}]);

directives.directive('registerCard', ['$rootScope', '$parse', '$filter', 'live', function($rootScope, $parse, $filter, live) {
    return {
        link: function($scope , element, attrs) {
            var keypress = '';
            var model = $parse(attrs.ngModel);
            var modelSetter = model.assign;
            var listening = false;

            var finished = function() {
                modelSetter($scope, keypress);
                element.removeClass('btn-warning');
                element.addClass('btn-success');
                element.text($filter('translate')('Card/tag has been linked'));
                listening = false;
                $rootScope.listeningForInput = false;
            };

            element.bind('click', function() {
                if (listening) {
                    return;
                }
                modelSetter($scope, '');
                keypress = '';
                listening = true;
                $rootScope.listeningForInput = true;
                element.text($filter('translate')('Waiting ...'));
                element.addClass('btn-warning');
                element.removeClass('btn-success');
            });
            element.bind('blur', function() {
                if (listening) {
                    listening = false;
                    $rootScope.listeningForInput = false;
                    element.text($filter('translate')('Register card'));
                    element.removeClass('btn-warning');
                    element.addClass('btn-success');
                }
            });
            $scope.$on('keypress', function(onEvent, keypressEvent) {
                if (!listening) {
                    return;
                }

                if (keypressEvent.keyCode == 13 || keypressEvent.keyCode == 9) {
                    if (keypress.length) {
                        finished();
                    }
                } else {
                    var charCode = (typeof keypressEvent.which == "number") ? keypressEvent.which : keypressEvent.keyCode;
                    keypress += String.fromCharCode(charCode);
                }
            });

            live.subscribe( {
                type: 'failedentry',
                action: 'add',
                scope: $scope,
                callback: function(failedEntry) {
                    if (!listening){
                        return;
                    }

                    var hasEnteredValue = keypress.length;
                    if (failedEntry.cardId && !hasEnteredValue) {
                        keypress = failedEntry.cardId;
                        finished();
                        $scope.$apply();
                    }
                }}
            );
        },
        restrict: 'A'
    };
}]);

directives.directive('registerCardUpdate', ['$rootScope', '$parse', '$filter', function($rootScope, $parse, $filter) {
    return {
        link: function($scope , element, attrs) {
            var keypress = '';
            var model = $parse(attrs.ngModel);
            var callback = attrs.onCardSet?$parse(attrs.onCardSet):null;
            var modelSetter = model.assign;
            var listening = false;

            function resetButton() {
                element.removeClass('btn-warning');
                element.removeClass('btn-info');
                element.addClass('btn-success');
                element.text($filter('translate')('Register card'));
            }

            var finished = function() {
                modelSetter($scope, keypress);
                listening = false;
                $rootScope.listeningForInput = false;
                if(callback) {
                    callback($scope).then(resetButton);
                } else {
                    resetButton();
                }
            };

            element.bind('click', function() {
                if (listening) {
                    return;
                }
                modelSetter($scope, '');
                keypress = '';
                listening = true;
                $rootScope.listeningForInput = true;
                element.text($filter('translate')('Waiting ...'));
                element.addClass('btn-warning');
                element.removeClass('btn-info');
                element.removeClass('btn-success');
            });
            element.bind('blur', function() {
                if (listening) {
                    listening = false;
                    $rootScope.listeningForInput = false;
                    resetButton();
                }
            });
            $scope.$on('keypress', function(onEvent, keypressEvent) {
                if (!listening) {
                    return;
                }

                if (keypressEvent.keyCode == 13 || keypressEvent.keyCode == 9) {
                    if (keypress.length) {
                        finished();
                    }
                } else {
                    var charCode = (typeof keypressEvent.which == "number") ? keypressEvent.which : keypressEvent.keyCode;
                    keypress += String.fromCharCode(charCode);
                }
            });

        },
        restrict: 'A'
    };
}]);

directives.directive('bankgiroNumber', [function() {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            ctrl.$parsers.unshift(function(viewValue) {
                if (!viewValue) {
                    ctrl.$setValidity('bankgiroNumber', true);
                    return null;
                }
                var isValid = function(x) {
                    return x && x.match(/^\d\d\d\d?-?\d\d\d\d?$/g);
                };
                var valid = isValid(viewValue);
                ctrl.$setValidity('bankgiroNumber', valid);

                return valid ? viewValue : undefined;
            });
        }
    };
}]);

directives.directive('loginkeyChecker', ['$rootScope', '$parse', function($rootScope, $parse) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var collision = $parse(attrs.loginkeyCheckerCollision);
            var original = $parse(attrs.loginkeyCheckerOriginal);
            ctrl.$parsers.unshift(function(viewValue) {
                var viewValueLower = viewValue && viewValue.toLowerCase();
                var list = $rootScope.members;
                var c;
                var o = original(scope);
                for (var i=0; i < list.length; ++i) {
                    if (o && list[i].login_key == o) {
                        continue;
                    }
                    if (list[i].login_key && list[i].login_key.toLowerCase() == viewValueLower) {
                        c = list[i];
                        break;
                    }
                }
                collision.assign(scope, c);
                ctrl.$setValidity('loginkeyUnique', !c);

                return !c ? viewValue : undefined;
            });
        }
    };
}]);

directives.directive('memberNumberChecker', ['$rootScope', '$parse', function($rootScope, $parse) {
    return {
        require: 'ngModel',
        link: function(scope, elm, attrs, ctrl) {
            var collision = $parse(attrs.memberNumberCheckerCollision);
            ctrl.$parsers.unshift(function(viewValue) {
                var c = _.findWhere($rootScope.members, {memberNumber: Number(viewValue)});
                collision.assign(scope, c);
                ctrl.$setValidity('memberNumberUnique', !c);

                return !c ? viewValue : undefined;
            });
        }
    };
}]);

directives.directive('stats', ['$filter', 'server', 'formatter',
    function($filter, server, formatter) {
      return {
        restrict: 'A',
        scope: {
            from: '=',
            to: '=',
            view: '=',
            hovertitle: '=',
            api: '=?',
            apiPost: '=?',
            format: '=',
            roundPerMonth: '=',
            data: '=?',
            cards: '=?'
        },
        link: function(scope, ele) {
            var shortMonthName = function(m) {
                return $filter('translate')(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][m]);
            };

            var longMonthName = function(m) {
                return $filter('translate')(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][m]);
            };

            var weekDay = function(d) {
                return $filter('translate')(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'][d]);
            };

            var daysInMonth = function(year, month) {
                return new Date(year, month, 0).getDate();
            };

            var createMonthChart = function(data, yearsArray) {
                var ykeys = [];
                for (var i=0; i < yearsArray.length; ++i) {
                    ykeys.push(yearsArray[i].toString());
                }

                var options = {
                    element: ele[0],
                    data: data,
                    xkey: 'month',
                    ykeys: ykeys,
                    labels: ykeys,
                    lineWidth: 2,
                    parseTime: false,
                    xLabelFormat: function(x) { return shortMonthName(x.x); },
                    yLabelFormat: scope.format && function(x) { return formatter.format(scope.format, x); },
                    lineColors: ["#FF7857","#FDD761","#A3C86D", '#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed'],
                    resize: true,
                    hoverCallback: function (index, options, content) {
                        var sn = shortMonthName(index);
                        return content.replace(sn, longMonthName(index));
                    }
                };

                ele.empty();
                new Morris.Line(options);
            };

            var createDayChart = function(data) {
                var days = {};
                for (var i=1; i <= 31; ++i) {
                    days[i] = { visits: 0, day: i};
                }
                _.each(_.keys(data), function(day) {
                    if (isNaN(day)) {
                        var mday = Date.newFull(day).getDate();
                        days[mday].visits += Number(data[day]);
                    } else {
                        days[Number(day)].visits = Number(data[day]);
                    }
                });

                var options = {
                    element: ele[0],
                    data: _.values(days),
                    xkey: 'day',
                    ykeys: ['visits'],
                    labels: ['visits'],
                    lineWidth: 2,
                    parseTime: false,
                    resize: true,
                    hoverCallback: function (index, options, content) {
                        return content.replace('visits', $filter('translate')(scope.hovertitle));
                    }
                };

                ele.empty();
                new Morris.Line(options);
            };

            var createWeekDayChart = function(data) {
                var days = {};
                for (var i=0; i < 7; ++i) {
                    days[i] = { visits: 0, day: i};
                }
                _.each(_.keys(data), function(day) {
                    var mday = Date.newFull(day).getDay() - 1;
                    if (mday == -1) {
                        mday = 6;
                    }
                    days[mday].visits += Number(data[day]);
                });

                var options = {
                    element: ele[0],
                    data: _.values(days),
                    xkey: 'day',
                    ykeys: ['visits'],
                    labels: ['visits'],
                    xLabelFormat: function(x) { return weekDay(x.x); },
                    lineWidth: 2,
                    parseTime: false,
                    resize: true,
                    hoverCallback: function (index, options, content) {
                        return content.replace('visits', $filter('translate')(scope.hovertitle));
                    }
                };

                ele.empty();
                new Morris.Line(options);
            };

            var createHourChart = function(data) {
                var hours = {};
                for (var i=0; i < 24; ++i) {
                    hours[i] = { visits: 0, hour: i};
                }

                _.each(_.keys(data), function(hour) {
                    if (!hours[hour]) {
                        hours[hour] = {visits: 0, hour: hour};
                    }
                    hours[hour].visits += Number(data[hour]);
                });

                var options = {
                    element: ele[0],
                    data: _.values(hours),
                    xkey: 'hour',
                    ykeys: ['visits'],
                    labels: ['visits'],
                    lineWidth: 2,
                    parseTime: false,
                    resize: true,
                    hoverCallback: function (index, options, content) {
                        return content.replace('visits', $filter('translate')(scope.hovertitle));
                    }
                };

                ele.empty();
                new Morris.Line(options);
            };

            var gotData = function(data) {
                if (scope.view == 'Months') {
                    var yearsArray = [];
                    for (var i=scope.from.getFullYear(); i <= scope.to.getFullYear(); ++i) {
                        yearsArray.push(i);
                    }

                    var d = new Date(scope.from.getTime());
                    var res = [];
                    do {
                        var year = d.getFullYear();
                        var month = d.getMonth();
                        if (!res[month]) {
                            res[month] = {};
                        }

                        if (!res[month][year]) {
                            res[month][year] = 0;
                        }

                        if (Number(data[d.yyyymmdd()])) {
                            res[month][year] += Number(data[d.yyyymmdd()]);
                        }

                        d.setDate(d.getDate() + 1);

                        if (scope.roundPerMonth) {
                            if (d.getDate() == 1) {
                                var dim = daysInMonth(year, month+1);
                                res[month][year] = Math.round(res[month][year] / dim);
                            } else if (d >= scope.to) {
                                var dim = scope.to.getDate();
                                res[month][year] = Math.round(res[month][year] / dim);
                            }
                        }
                    } while (d < scope.to);

                    createMonthChart(res, yearsArray);
                } else if (scope.view == 'Days') {
                    createDayChart(data);
                } else if (scope.view == 'Week days') {
                    createWeekDayChart(data);
                } else if (scope.view == 'Hours') {
                    createHourChart(data);
                }
            };

            var getData = function() {
                if (scope.data) {
                    gotData(scope.data);
                } else {
                    if (!scope.from || !scope.to || scope.from.getFullYear() < 2000 || scope.to.getFullYear() < 2000) {
                        return;
                    }
                    var args = {fromDate: scope.from.yyyymmdd(), toDate: scope.to.yyyymmdd(), hour: (scope.view == 'Hours')};
                    if (scope.cards) {
                        args.cards = _.pluck(scope.cards, 'id');
                    }

                    if (scope.apiPost) {
                        server.post(scope.api, args, null).then(function(result) {
                            if (result.success) {
                                gotData(result.data);
                            }
                        });
                    } else {
                        server.get(scope.api, args).then(gotData);
                    }
                }
            };

            scope.$watchGroup(['from', 'to', 'view', 'data', 'cards'], function() {
                getData();
            });
        }
      };
    }
]);

directives.directive('newstats', ['$filter', '$translate', 'echartslib',
    function($filter, $translate, echartslib) {
      return {
        restrict: 'A',
        scope: {
            data: '='
        },
        link: function(scope, ele) {
            var diagrams = {};

            var months_short = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            var months_short_translated = [];
            months_short.forEach(function(m) {
                months_short_translated.push($filter('translate')(m));
            });

            // Week days starts on sunday (setting to change to monday later)
            var weekdays_short = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
            var weekdays_short_translated = [];
            var language = $translate.use();
            if (language == 'en') {
                weekdays_short_translated = weekdays_short;
            } else {
                weekdays_short_translated = ['S', 'M', 'T', 'O', 'T', 'F', 'L'];
            }

            diagrams.linebar = function(data, type) {
                var series = [];
                var ddata = Array.isArray(data.data) ? data.data : [data];
                var xdata;
                ddata.forEach(function(x) {
                    series.push( {
                        name: ddata.length > 1 ? x.name : $filter('translate')(x.datatype.name) + ' > ' + $filter('translate')(x.timeproperty.name),
                        type: type,
                        smooth: true,
                        itemStyle: {normal: {color: x.color}},
                        data: x.data.y
                    });
                    if (!xdata) {
                        xdata = x.data.x;
                    }
                });

                var option = {
                    title: {
                        text: data.title
                    },
                    tooltip: {},
                    legend: {
                        show: series.length > 1,
                        data: _.pluck(series, 'name')
                    },
                    xAxis: {
                        data: xdata
                    },
                    yAxis: {},
                    series: series,
                    toolbox: {
                        feature: {
                            dataZoom: {
                                yAxisIndex: 'none',
                                title: 'Zoom'
                            },
                            restore: {
                                title: $filter('translate')('Restore')
                            },
                            saveAsImage: {
                                title: $filter('translate')('Save')
                            }
                        }
                    },
                    dataZoom: [{
                        startValue: xdata[0]
                    }, {
                        type: 'inside'
                    }]
                };
                return option;
            };

            diagrams.line = function(data) {
                return diagrams.linebar(data, 'line');
            };

            diagrams.bar = function(data) {
                return diagrams.linebar(data, 'bar');
            };

            diagrams.heatmap = function(data) {
                var caldata = [];
                var keys = data.data.x;
                keys.forEach(function(k, index) {
                    caldata.push([k, data.data.y[index]]);
                });

                var option = {
                    title: {
                        text: data.title
                    },
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        show: false
                    },
                    visualMap: {
                        min: 0,
                        max: Math.max.apply(null, data.data.y),
                        type: 'piecewise',
                        orient: 'horizontal',
                        left: 'center',
                        top: 65,
                        textStyle: {
                            color: '#000'
                        }/*,
                        inRange: {
                            color: ['#fff', '#eee', '#ddd', '#ccc', '#bbb', '#aaa']
                        }*/
                    },
                    calendar: {
                        top: 120,
                        left: 30,
                        right: 30,
                        cellSize: ['auto', 13],
                        range: [keys[0], keys[keys.length-1]],
                        itemStyle: {
                            normal: {borderWidth: 0.5}
                        },
                        yearLabel: {show: false},
                        dayLabel: {
                            firstDay: 1,
                            nameMap: weekdays_short_translated
                        },
                        monthLabel: {
                            nameMap: months_short_translated
                        }
                    },
                    series: [{
                        name: $filter('translate')(data.datatype.name) + ' > ' + $filter('translate')(data.timeproperty.name),
                        type: 'heatmap',
                        coordinateSystem: 'calendar',
                        data: caldata,
                        tooltip: '{c}'
                    }]
                };
                return option;
            };

            scope.$watch('data', function() {
                echartslib.load().then(function() {
                    var chart = echarts.init(ele[0]);
                    var option = diagrams[scope.data.reporttype](scope.data);
                    chart.setOption(option);
                });
            });
        }
      };
    }
]);

directives.directive('memberStats', ['$rootScope', '$filter', '$http', '$parse',
    function($rootScope, $filter, $http, $parse) {
      return {
        restrict: 'A',
        link: function(scope, ele, attrs) {
            var shortMonthName = function(m) {
                return $filter('translate')(["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][m]);
            };

            /*var longMonthName = function(m) {
                return $filter('translate')(["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][m]);
            };*/

            var createChart = function(data) {
                var ykeys = [];
                var labels = [];
                if ($rootScope.hasModule('WorkoutBooking')) {
                    ykeys.push('bookings');
                    labels.push($filter('translate')('STATS_BOOKINGS'));
                }
                if ($rootScope.hasModule('Entry')) {
                    ykeys.push('entries');
                    labels.push($filter('translate')('Entries'));
                }

                var options = {
                    element: ele[0],
                    data: data,
                    xkey: 'month',
                    ykeys: ykeys,
                    labels: labels,
                    lineWidth: 2,
                    xLabelFormat: function(x) { return shortMonthName(x.getMonth()); },
                    lineColors: ["#FF7857","#FDD761","#A3C86D", '#0b62a4', '#7a92a3', '#4da74d', '#afd8f8', '#edc240', '#cb4b4b', '#9440ed'],
                    resize: true
                };

                new Morris.Line(options);
            };

            var getData = function() {
                var customer = $parse(attrs.customer)(scope);

                var fromDate = Date.today().yearsAgo(1);
                var toDate = Date.today();

                $http.get('/api/stats/member?member=' + customer.id +  '&fromDate=' + fromDate.yyyymmdd() + '&toDate=' + toDate.yyyymmdd()).success(function(data) {
                    var d = new Date(fromDate.getTime());
                    var gdata = {};

                    do {
                        var yearMonth = d.yyyymmdd().substring(0,7);
                        if (!gdata[yearMonth]) {
                            gdata[yearMonth] = {month: yearMonth, bookings: 0, entries: 0};
                        }
                        var i = d.yyyymmdd();
                        if (data.bookings && data.bookings[i]) {
                            gdata[yearMonth].bookings += data.bookings[i];
                        }
                        if (data.entries && data.entries[i]) {
                            gdata[yearMonth].entries += data.entries[i];
                        }

                        d.setDate(d.getDate() + 1);
                    } while (d <= toDate);

                    createChart(_.values(gdata));
                });
            };

            getData();
        }
      };
    }
]);

/* jshint ignore:start */

/**
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to
 * deal in the Software without restriction, including without limitation the
 * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
 * sell copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
 * IN THE SOFTWARE.
 */

/**
 * Implementing Drag and Drop functionality in AngularJS is easier than ever.
 * Demo: http://codef0rmer.github.com/angular-dragdrop/
 *
 * @version 1.0.7
 *
 * (c) 2013 Amit Gharat a.k.a codef0rmer <amit.2006.it@gmail.com> - amitgharat.wordpress.com
 */

 // Fixed crasher (https://github.com/codef0rmer/angular-dragdrop/issues/110) by removing destructors

(function (window, angular, undefined) {

var jqyoui = angular.module('ngDragDrop', []).service('ngDragDropService', ['$timeout', '$parse', function($timeout, $parse) {
    this.callEventCallback = function (scope, callbackName, event, ui) {
      if (!callbackName) return;

      var objExtract = extract(callbackName),
          callback = objExtract.callback,
          constructor = objExtract.constructor,
          args = [event, ui].concat(objExtract.args);

      // call either $scoped method i.e. $scope.dropCallback or constructor's method i.e. this.dropCallback
      scope.$apply((scope[callback] || scope[constructor][callback]).apply(scope, args));

      function extract(callbackName) {
        var atStartBracket = callbackName.indexOf('(') !== -1 ? callbackName.indexOf('(') : callbackName.length,
            atEndBracket = callbackName.lastIndexOf(')') !== -1 ? callbackName.lastIndexOf(')') : callbackName.length,
            args = callbackName.substring(atStartBracket + 1, atEndBracket), // matching function arguments inside brackets
            constructor = callbackName.match(/^[^.]+.\s*/)[0].slice(0, -1); // matching a string upto a dot to check ctrl as syntax
            constructor = scope[constructor] && typeof scope[constructor].constructor === 'function' ? constructor : null;

        return {
          callback: callbackName.substring(constructor && constructor.length + 1 || 0, atStartBracket),
          args: (args && args.split(',') || []).map(function(item) { return $parse(item)(scope); }),
          constructor: constructor
        }
      }
    };

    this.invokeDrop = function ($draggable, $droppable, event, ui) {
      var dragModel = '',
        dropModel = '',
        dragSettings = {},
        dropSettings = {},
        jqyoui_pos = null,
        dragItem = {},
        dropItem = {},
        dragModelValue,
        dropModelValue,
        $droppableDraggable = null,
        droppableScope = $droppable.scope(),
        draggableScope = $draggable.scope();

      dragModel = $draggable.ngattr('ng-model');
      dropModel = $droppable.ngattr('ng-model');
      dragModelValue = draggableScope.$eval(dragModel);
      dropModelValue = droppableScope.$eval(dropModel);

      $droppableDraggable = $droppable.find('[jqyoui-draggable]:last,[data-jqyoui-draggable]:last');
      dropSettings = droppableScope.$eval($droppable.attr('jqyoui-droppable') || $droppable.attr('data-jqyoui-droppable')) || [];
      dragSettings = draggableScope.$eval($draggable.attr('jqyoui-draggable') || $draggable.attr('data-jqyoui-draggable')) || [];

      // Helps pick up the right item
      dragSettings.index = this.fixIndex(draggableScope, dragSettings, dragModelValue);
      dropSettings.index = this.fixIndex(droppableScope, dropSettings, dropModelValue);

      jqyoui_pos = angular.isArray(dragModelValue) ? dragSettings.index : null;
      dragItem = angular.copy(angular.isArray(dragModelValue) ? dragModelValue[jqyoui_pos] : dragModelValue);

      if (angular.isArray(dropModelValue) && dropSettings && dropSettings.index !== undefined) {
        dropItem = dropModelValue[dropSettings.index];
      } else if (!angular.isArray(dropModelValue)) {
        dropItem = dropModelValue;
      } else {
        dropItem = {};
      }
      dropItem = angular.copy(dropItem);

      if (dragSettings.animate === true) {
        this.move($draggable, $droppableDraggable.length > 0 ? $droppableDraggable : $droppable, null, 'fast', dropSettings, null);
        this.move($droppableDraggable.length > 0 && !dropSettings.multiple ? $droppableDraggable : [], $draggable.parent('[jqyoui-droppable],[data-jqyoui-droppable]'), jqyoui.startXY, 'fast', dropSettings, angular.bind(this, function() {
          $timeout(angular.bind(this, function() {
            // Do not move this into move() to avoid flickering issue
            $draggable.css({'position': 'relative', 'left': '', 'top': ''});
            // Angular v1.2 uses ng-hide to hide an element not display property
            // so we've to manually remove display:none set in this.move()
            $droppableDraggable.css({'position': 'relative', 'left': '', 'top': '', 'display': ''});

            this.mutateDraggable(draggableScope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable);
            this.mutateDroppable(droppableScope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos);
            this.callEventCallback(droppableScope, dropSettings.onDrop, event, ui);
          }));
        }));
      } else {
        $timeout(angular.bind(this, function() {
          this.mutateDraggable(draggableScope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable);
          this.mutateDroppable(droppableScope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos);
          this.callEventCallback(droppableScope, dropSettings.onDrop, event, ui);
        }));
      }
    };

    this.move = function($fromEl, $toEl, toPos, duration, dropSettings, callback) {
      if ($fromEl.length === 0) {
        if (callback) {
          window.setTimeout(function() {
            callback();
          }, 300);
        }
        return false;
      }

      var zIndex = 9999,
        fromPos = $fromEl[dropSettings.containment || 'offset'](),
        wasVisible = $toEl && $toEl.is(':visible'),
        hadNgHideCls = $toEl.hasClass('ng-hide');

      if (toPos === null && $toEl.length > 0) {
        if (($toEl.attr('jqyoui-draggable') || $toEl.attr('data-jqyoui-draggable')) !== undefined && $toEl.ngattr('ng-model') !== undefined && $toEl.is(':visible') && dropSettings && dropSettings.multiple) {
          toPos = $toEl[dropSettings.containment || 'offset']();
          if (dropSettings.stack === false) {
            toPos.left+= $toEl.outerWidth(true);
          } else {
            toPos.top+= $toEl.outerHeight(true);
          }
        } else {
          // Angular v1.2 uses ng-hide to hide an element
          // so we've to remove it in order to grab its position
          if (hadNgHideCls) $toEl.removeClass('ng-hide');
          toPos = $toEl.css({'visibility': 'hidden', 'display': 'block'})[dropSettings.containment || 'offset']();
          $toEl.css({'visibility': '','display': wasVisible ? 'block' : 'none'});
        }
      }

      $fromEl.css({'position': 'absolute', 'z-index': zIndex})
        .css(fromPos)
        .animate(toPos, duration, function() {
          // Angular v1.2 uses ng-hide to hide an element
          // and as we remove it above, we've to put it back to
          // hide the element (while swapping) if it was hidden already
          // because we remove the display:none in this.invokeDrop()
          if (hadNgHideCls) $toEl.addClass('ng-hide');
          if (callback) callback();
        });
    };

    this.mutateDroppable = function(scope, dropSettings, dragSettings, dropModel, dragItem, jqyoui_pos) {
      var dropModelValue = scope.$eval(dropModel);

      scope.dndDragItem = dragItem;

      if (angular.isArray(dropModelValue)) {
        if (dropSettings && dropSettings.index >= 0) {
          dropModelValue[dropSettings.index] = dragItem;
        } else {
          dropModelValue.push(dragItem);
        }
        if (dragSettings && dragSettings.placeholder === true) {
          dropModelValue[dropModelValue.length - 1]['jqyoui_pos'] = jqyoui_pos;
        }
      } else {
        $parse(dropModel + ' = dndDragItem')(scope);
        if (dragSettings && dragSettings.placeholder === true) {
          dropModelValue['jqyoui_pos'] = jqyoui_pos;
        }
      }
    };

    this.mutateDraggable = function(scope, dropSettings, dragSettings, dragModel, dropModel, dropItem, $draggable) {
      var isEmpty = angular.equals(dropItem, {}),
        dragModelValue = scope.$eval(dragModel);

      scope.dndDropItem = dropItem;

      if (dragSettings && dragSettings.placeholder) {
        if (dragSettings.placeholder != 'keep'){
          if (angular.isArray(dragModelValue) && dragSettings.index !== undefined) {
            dragModelValue[dragSettings.index] = dropItem;
          } else {
            $parse(dragModel + ' = dndDropItem')(scope);
          }
        }
      } else {
        if (angular.isArray(dragModelValue)) {
          if (isEmpty) {
            if (dragSettings && ( dragSettings.placeholder !== true && dragSettings.placeholder !== 'keep' )) {
              dragModelValue.splice(dragSettings.index, 1);
            }
          } else {
            dragModelValue[dragSettings.index] = dropItem;
          }
        } else {
          // Fix: LIST(object) to LIST(array) - model does not get updated using just scope[dragModel] = {...}
          // P.S.: Could not figure out why it happened
          $parse(dragModel + ' = dndDropItem')(scope);
          if (scope.$parent) {
            $parse(dragModel + ' = dndDropItem')(scope.$parent);
          }
        }
      }

      $draggable.css({'z-index': '', 'left': '', 'top': ''});
    };

    this.fixIndex = function(scope, settings, modelValue) {
      if (settings.applyFilter && angular.isArray(modelValue) && modelValue.length > 0) {
        var dragModelValueFiltered = scope[settings.applyFilter](),
            lookup = dragModelValueFiltered[settings.index],
            actualIndex = undefined;

        modelValue.forEach(function(item, i) {
           if (angular.equals(item, lookup)) {
             actualIndex = i;
           }
        });

        return actualIndex;
      }

      return settings.index;
    };
  }]).directive('jqyouiDraggable', ['ngDragDropService', function(ngDragDropService) {
    return {
      require: '?jqyouiDroppable',
      restrict: 'A',
      link: function(scope, element, attrs) {
        var dragSettings, jqyouiOptions, zIndex;
        var updateDraggable = function(newValue, oldValue) {
          if (newValue) {
            dragSettings = scope.$eval(element.attr('jqyoui-draggable') || element.attr('data-jqyoui-draggable')) || {};
            jqyouiOptions = scope.$eval(attrs.jqyouiOptions) || {};
            element
              .draggable({disabled: false})
              .draggable(jqyouiOptions)
              .draggable({
                start: function(event, ui) {
                  zIndex = angular.element(jqyouiOptions.helper ? ui.helper : this).css('z-index');
                  angular.element(jqyouiOptions.helper ? ui.helper : this).css('z-index', 9999);
                  jqyoui.startXY = angular.element(this)[dragSettings.containment || 'offset']();
                  ngDragDropService.callEventCallback(scope, dragSettings.onStart, event, ui);
                },
                stop: function(event, ui) {
                  angular.element(jqyouiOptions.helper ? ui.helper : this).css('z-index', zIndex);
                  ngDragDropService.callEventCallback(scope, dragSettings.onStop, event, ui);
                },
                drag: function(event, ui) {
                  ngDragDropService.callEventCallback(scope, dragSettings.onDrag, event, ui);
                }
              });
          } else {
            element.draggable({disabled: true});
          }
        };
        scope.$watch(function() { return scope.$eval(attrs.drag); }, updateDraggable);
        updateDraggable();

        /*element.on('$destroy', function() {
          element.draggable('destroy');
        });*/
      }
    };
  }]).directive('jqyouiDroppable', ['ngDragDropService', function(ngDragDropService) {
    return {
      restrict: 'A',
      priority: 1,
      link: function(scope, element, attrs) {
        var dropSettings;
        var updateDroppable = function(newValue, oldValue) {
          if (newValue) {
            dropSettings = scope.$eval(angular.element(element).attr('jqyoui-droppable') || angular.element(element).attr('data-jqyoui-droppable')) || {};
            element
              .droppable({disabled: false})
              .droppable(scope.$eval(attrs.jqyouiOptions) || {})
              .droppable({
                over: function(event, ui) {
                  ngDragDropService.callEventCallback(scope, dropSettings.onOver, event, ui);
                },
                out: function(event, ui) {
                  ngDragDropService.callEventCallback(scope, dropSettings.onOut, event, ui);
                },
                drop: function(event, ui) {
                  if (angular.element(ui.draggable).ngattr('ng-model') && attrs.ngModel) {
                    ngDragDropService.invokeDrop(angular.element(ui.draggable), angular.element(this), event, ui);
                  } else {
                    ngDragDropService.callEventCallback(scope, dropSettings.onDrop, event, ui);
                  }
                }
              });
          } else {
            element.droppable({disabled: true});
          }
        };

        scope.$watch(function() { return scope.$eval(attrs.drop); }, updateDroppable);
        updateDroppable();

        /*element.on('$destroy', function() {
          element.droppable('destroy');
        });*/
      }
    };
  }]);

  $.fn.ngattr = function(name, value) {
    var element = angular.element(this).get(0);

    return element.getAttribute(name) || element.getAttribute('data-' + name);
  };
})(window, window.angular);

/* jshint ignore:end */

// Post repeat directive for logging the rendering time
directives.directive('postRepeatDirective', ['$timeout', function($timeout) {
    return function(scope, e, attrs) {
        var name = attrs.postRepeatDirective;
        if (scope.$first) {
            window[name] = new Date();   // window[name] can be updated anywhere if to reset counter at some action if ng-repeat is not getting started from $first
        }
        if (scope.$last) {
            $timeout(function(){
                console.log("## DOM rendering list took: " + (new Date() - window[name]) + " ms");
            });
        }
    };
}]);

angular.module('ui.bootstrap-slider', [])
    .directive('slider', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'AE',
            replace: true,
            template: '<input type="text" />',
            link: function ($scope, element, attrs) {
                var model = $parse(attrs.ngModel);

                $.fn.slider.Constructor.prototype.disable = function () {
                    this.picker.off();
                };
                $.fn.slider.Constructor.prototype.enable = function () {
                    if (this.touchCapable) {
                        // Touch: Bind touch events:
                        this.picker.on({
                            touchstart: $.proxy(this.mousedown, this)
                        });
                    } else {
                        this.picker.on({
                            mousedown: $.proxy(this.mousedown, this)
                        });
                    }
                };

                var options = {};
                if(attrs.sliderId) { options.id = attrs.sliderId;  }
                if(attrs.min) { options.min = parseFloat(attrs.min) || 1; }
                if(attrs.max) { options.max = parseFloat(attrs.max) || 100; }
                if(attrs.step) { options.step = parseFloat(attrs.step); }
                if(attrs.precision) { options.precision = parseFloat(attrs.precision); }
                if(attrs.orientation) { options.orientation = attrs.orientation; }
                if(attrs.value) {
                    if (angular.isNumber(attrs.value) || angular.isArray(attrs.value)) {
                        options.value = attrs.value;
                    } else if (angular.isString(attrs.value)) {
                        if (attrs.value.indexOf("[") === 0) {
                            options.value = angular.fromJson(attrs.value);
                        } else {
                            options.value = parseFloat(attrs.value);
                        }
                    }

                }
                if(attrs.range) { options.range = attrs.range === 'true'; }
                if(attrs.selection) { options.selection = attrs.selection; }
                if(attrs.tooltip) { options.tooltip = attrs.tooltip; }
                if(attrs.tooltipSeparator) { options.tooltip_separator = attrs.tooltipSeparator; }
                if(attrs.tooltipSplit) { options.tooltip_split = attrs.tooltipSplit === 'true'; }
                if(attrs.handle) { options.handle = attrs.handle; }
                if(attrs.reversed) { options.reversed = attrs.reversed === 'true'; }
                if(attrs.enabled) { options.enabled = attrs.enabled === 'true'; }
                if(attrs.naturalArrowKeys) { options.natural_arrow_keys = attrs.naturalArrowKeys === 'true'; }
                if(attrs.formater) { options.formater = $scope.$eval(attrs.formater); }

                if (options.range && !options.value) {
                    options.value = [0,0]; // This is needed, because of value defined at $.fn.slider.defaults - default value 5 prevents creating range slider
                }

                /*if (model($scope) == undefined) {
                    model.assign($scope, options.value);
                }*/

                var slider = $(element[0]).slider(options);
                var updateEvent = attrs.updateEvent || 'slide';

                slider.on(updateEvent, function(ev) {
                    model.assign($scope, ev.value);
                    $timeout(function() {
                        $scope.$apply();
                    });
                });

                $scope.$watch(attrs.ngModel, function(value) {
                    if (options.range) {
                        if (value[1] < value[0]) {
                            var tmp = value[1];
                            value[1] = value[0];
                            value[0] = tmp;
                        }
                        slider.slider('setValue', value);
                    } else {
                        if(value || value === 0) {
                            slider.slider('setValue', value, false);
                        }
                    }
                });

                if (attrs.ngDisabled) {
                    $scope.$watch(attrs.ngDisabled, function (value) {
                        if (value) {
                            slider.slider('disable');
                        } else {
                            slider.slider('enable');
                        }
                    });
                }
            }
        };
    }])
;

function calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
    var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
    return { width: srcWidth*ratio, height: srcHeight*ratio };
}

directives.directive('middle', function() {
    return {
        restrict: 'A',
        link: function(scope, element) {
            element.bind('load', function() {
                var imgWidth = element.width();
                var imgHeight = element.height();
                var width = $(window).width();
                var height = $(window).height();
                var useWidth = Math.min(width, imgWidth);
                var useHeight = Math.min(height, imgHeight);

                var ar = calculateAspectRatioFit(imgWidth, imgHeight, useWidth, useHeight);

                imgWidth = ar.width;
                imgHeight = ar.height;

                var left = (width - imgWidth) / 2;
                var top = (height - imgHeight) / 2;
                element.css({left: left, top: top, width: imgWidth, height: imgHeight });

                element.animate({opacity: 1});

                scope.imgWidth = imgWidth;
                scope.imgHeight = imgHeight;
            });
        }
    };
});

directives.filter('orderByTranslated', ['$filter', function($filter) {
    return function(array, property) {
        var result = [];
        var translated = [];
        angular.forEach(array, function(value) {
            translated.push({key: value, label: $filter('translate')(value[property])});
        });
        angular.forEach($filter('orderBy')(translated, 'label'), function(sortedObject) {
            result.push(sortedObject.key);
        });
        return result;
    };
}]);

directives.factory('FeedService',['$http',function($http){
    return {
        parseFeed : function(url){
            return $http.jsonp('//ajax.googleapis.com/ajax/services/feed/load?v=1.0&num=5&callback=JSON_CALLBACK&q=' + encodeURIComponent(url));
        }
    };
}]);

directives.directive('compacttable', ['formatter', function (formatter) {
    return {
        restrict: 'E',
        templateUrl: 'views/compacttable.html',
        scope: {
            items: '='
        },
        link: function(scope) {
            scope.getValue = function(item) {
                return item.format ? formatter.format(item.format, item.value) : item.value;
            };
        }
    };
}]);

directives.directive('customerinfo', ['$rootScope', function($rootScope) {
    return {
        restrict: 'E',
        templateUrl: 'views/customerinfo.html',
        scope: {
            customer: '='
        },
        link: function(scope) {
            scope.getMember = $rootScope.getMember;
            scope.hasModule = $rootScope.hasModule;
        }
    };
}]);

directives.filter('niceNumber', ['formatter', function (formatter) {
    return function (x) {
        return formatter.format('float', x);
    };
}]);

directives.filter('percentage', ['formatter', function (formatter) {
    return function (x) {
        return formatter.format('percentage', x);
    };
}]);

directives.directive('saveState', function() {
    var state = {};

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            name: '=saveState',
            item: '=ngModel'
        },
        link: function($scope, element, attrs) {
            if (state[attrs.saveState] !== undefined) {
                $scope.item = state[attrs.saveState];
            }

            $scope.$watch('item', function(newValue, oldValue) {
                if (newValue != oldValue) {
                    state[attrs.saveState] = newValue;
                }
            });
        }
    };
});

directives.directive('saveHistoryState', ['$rootScope', 'history', function($rootScope, history) {
    var state = {};

    return {
        restrict: 'A',
        require: 'ngModel',
        scope: {
            name: '=saveHistoryState',
            item: '=ngModel'
        },
        link: function($scope, element, attrs) {
            var s = $scope.$parent.$eval(attrs.saveHistoryState);
            if (!s) {
                return;
            }
            if (state[s] !== undefined) {
                if (history.isBack()) {
                    $scope.item = state[s];
                }
            }

            $scope.$watch('item', function(newValue, oldValue) {
                if (newValue != oldValue) {
                    state[s] = newValue;
                }
            });
        }
    };
}]);

directives.directive('paymentsearch', ['paymentMethods', '$location', 'util', function(paymentMethods, $location, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/paymentsearch.html',
        scope: {
            config: '='
        },
        link: function(scope, element) {
            scope.config.searchFilter = function(p) {
                if(scope.config.unconfirmed && p.confirmed) {return false;}
                if (!scope.search.method) {
                    if (scope.filterMethods) {
                        return scope.filterMethods.indexOf(p.method) != -1;
                    }
                    return true;
                }
                if(Array.isArray(scope.search.method)) {
                    var ok = false;
                    scope.search.method.forEach(function(m) {
                        if(m == p.method) {ok = true;}
                    });
                    return ok;
                }
                return scope.search.method.id == p.method;
            };

            scope.getPaymentMethods = function() {
                var methods = paymentMethods.getAll();
                if (scope.filterMethods) {
                    methods = _.filter(methods, function(method) { return scope.filterMethods.indexOf(method.id) != -1; });
                }
                return methods;
            };

            scope.methodChanged = function() {
                scope.config.control.update();
            };

            scope.config.getSaveStateName = function() {
                return util.getSaveStateName($location.path(), element);
            };

            scope.search = { method: scope.config.searchMethod };
            scope.filterMethods = scope.config.searchMethod;
            if (scope.filterMethods && !Array.isArray(scope.filterMethods)) {
                scope.filterMethods = [scope.filterMethods];
            }
        }
    };
}]);

directives.directive('entrysearch', ['$rootScope', 'server', '$location', 'util', function($rootScope, server, $location, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/entrysearch.html',
        scope: {
            config: '='
        },
        link: function(scope, element) {
            scope.getDoors = function() {
                return $rootScope.staffs;
            };

            scope.isActiveDoor = function(s) {
                return s.active && s.type == 'resource' && (s.resourceType == 'door' || s.resourceType == 'qrcode_entry');
            };

            scope.hasDoors = function() {
                return scope.getDoors().filter(scope.isActiveDoor).length;
            };

            scope.config.searchFilter = function(entry) {
                return !scope.search.door || scope.search.door == entry.door;
            };

            scope.doorChanged = function() {
                scope.config.control.update();
            };

            scope.opening = {};
            function openDoor() {
                var door = scope.search.door;
                scope.opening[door.id] = true;
                server.post('/api/door/open', null, {id: door.id, admin_entry: true}).then(function() {
                    scope.opening[door.id] = false;
                });
            }

            if (scope.config.searchButtons) {
                scope.config.searchButtons.push(
                    {title: 'Open', onClick: openDoor, buttonClass: 'btn-success', visible: function() {var r = scope.search.door; return r && r.externaldoorid && $rootScope.extendedTidomatIntegration; }, loading: function() { var door = scope.search.door; return door && scope.opening[door.id];}}
                );
            }

            scope.config.getSaveStateName = function() {
                return util.getSaveStateName($location.path(), element);
            };

            scope.search = { };
        }
    };
}]);

directives.directive('filtercomponent', ['$rootScope', '$filter', 'propertyhelper', function($rootScope, $filter, propertyhelper) {
    return {
        restrict: 'E',
        templateUrl: 'views/filtercomponent.html',
        scope: {
            myModel: '=',
            info: '=',
            datatype: '=',
            resetInitView: '='
        },
        link: function(scope) {
            // The default types

            function setup(expression) {
                var and = { id: 'and', name: 'FILTER_AND', type: 'block'};
                var or = {id: 'or', name: 'FILTER_OR', type: 'block'};
                scope.types = [and, or];
                scope.operations = [{ id: 'eq', name: 'equals'}, {id: 'neq', name: 'unequals'}, {id: 'gt', name: 'greater than'}, {id: 'lt', name: 'less than'}, {id: 'gte', name: 'greater than or equal to'}, {id: 'lte', name: 'less than or equal to'}, {id: 'contains', name: 'contains'}, {id: 'notcontains', name: 'does not contain'}];

                var propertyTypes = scope.info.property_types;
                var types = propertyhelper.getExpandedProperties(scope.info, scope.datatype.id).filter(function(x) { return !x.primary && !x.nofilter; });
                Array.prototype.push.apply(scope.types, types.map(_.clone));
                var firstproperty = scope.types.length > 2 ? scope.types[2] : null;

                function flatten(f, parent) {
                    var rows = [];
                    if (f.type != 'expression') {
                        var o;
                        if (f.type == 'and') {
                            o = { type: and, parent: parent };
                        } else {
                            o = { type: or, parent: parent };
                        }
                        rows.push( o );

                        f.content.forEach(function(x) {
                            Array.prototype.push.apply(rows, flatten(x, o));
                        });
                    } else {
                        var p = _.findWhere(scope.types, {id: f.lhs});
                        var o = _.findWhere(scope.operations, {id: f.operation});
                        var value = (p&&(p.format === 'number' || p.format === 'bool'))?Number(f.rhs):f.rhs;
                        rows.push( { type: p, operation: o, value: value, parent: parent, oldType: p } );
                    }

                    return rows;
                }

                scope.rows = flatten(expression || { type: 'expression' });

                scope.add = function(row) {
                    var children = scope.rows.filter(function(x) { return x.parent == row; });
                    var i = scope.rows.indexOf(row);
                    var newrow = { parent: row.parent, type: firstproperty, operation: scope.operations[0], oldType: firstproperty };
                    scope.rows.splice(i+1+children.length, 0, newrow);
                };

                scope.canAdd = function(row) {
                    return row.parent;
                };

                scope.canRemove = function(row) {
                    if (!row.parent) {
                        return true;
                    }

                    if (row.parent) {
                        var siblings = scope.rows.filter(function(x) { return x.parent == row.parent; });
                        if (siblings.length == 1) {
                            return false;
                        }
                    }

                    return true;
                };

                scope.remove = function(row) {
                    if (!row.parent) {
                        scope.rows = flatten({ 'type': 'expression' });
                        return;
                    }

                    var children = scope.rows.filter(function(x) { return x.parent == row; });
                    children.forEach(function(c) {
                        scope.remove(c);
                    });
                    var i = scope.rows.indexOf(row);
                    scope.rows.splice(i, 1);
                };

                scope.changeType = function(row) {
                    var children = scope.rows.filter(function(x) { return x.parent == row; });
                    if (row.type.type != 'block') {
                        children.forEach(function(c) {
                            scope.remove(c);
                        });
                        row.operation = scope.operations[0];
                        if (row.oldType && row.oldType != row.type && scope.getInputType(row.oldType) != scope.getInputType(row.type)) {
                            row.rhs = undefined;
                            row.value = undefined;
                        }
                        if (row.type.format && propertyTypes[row.type.format]) {
                            if (!_.findWhere(propertyTypes[row.type.format], {id: row.value})) {
                                row.value = propertyTypes[row.type.format][0].id;
                            }
                        }
                    } else {
                        var oldrhs = row.rhs;
                        var oldvalue = row.value;
                        var oldop = row.operation;
                        delete row.rhs;
                        delete row.value;
                        delete row.operation;
                        if (children.length == 0) {
                            var i = scope.rows.indexOf(row);
                            var newtype = row.oldType || firstproperty;
                            var newop = row.oldType ? oldop : scope.operations[0];
                            var newrow = { parent: row, type: newtype, operation: newop, oldType: newtype };
                            if (row.oldType) {
                                newrow.rhs = oldrhs;
                                newrow.value = oldvalue;
                            }
                            scope.rows.splice(i+1, 0, newrow);
                        }
                    }
                    row.oldType = row.type;
                };

                scope.getTypePaddingClass = function(row) {
                    if (row.parent) {
                        if (row.parent.parent) {
                            if (row.parent.parent.parent) {
                                return 'col-sm-3';
                            }
                            return 'col-sm-2';
                        }
                        return 'col-sm-1';
                    }
                };

                scope.getTypeClass = function(row) {
                    if (row.parent) {
                        if (row.parent.parent) {
                            if (row.parent.parent.parent) {
                                return 'col-sm-1';
                            }
                            return 'col-sm-2';
                        }
                        return 'col-sm-3';
                    }
                    return 'col-sm-4';
                };

                scope.getTypeGroup = function(t) {
                    return t == 'block' ? 'ReportBlock' : 'Property';
                };

                scope.getTypeName = function(p) {
                    if (p.typename) {
                        return p.typename;
                    }

                    var res = '';
                    if (Array.isArray(p.name)) {
                        p.name.forEach(function(name) {
                            if (res.length) {
                                res += ' > ';
                            }
                            res += $filter('translate')(name);
                        });
                    } else {
                        res = $filter('translate')(p.name);
                    }
                    p.typename = res;
                    return res;
                };

                scope.getTypeOrder = function(t) {
                    if (t.type == 'block') return '0' + scope.getTypeName(t);
                    var isDirect = !Array.isArray(t.name) || t.name.length === 1;
                    return (isDirect ? '1' : '2') + scope.getTypeName(t);
                };

                function unflatten(row) {
                    var children = scope.rows.filter(function(x) { return x.parent == row; });
                    if (children.length == 0) {
                        return { type: 'expression', lhs: row.type.id, operation: row.operation.id, rhs: row.value};
                    } else {
                        var result = { type: row.type.id, content: [] };
                        children.forEach(function(row) {
                            result.content.push(unflatten(row));
                        });
                        return result;
                    }
                }

                function isValid() {
                    return _.every(scope.rows, function(x) {
                        return x.type && x.type.id && (x.type.type == 'block' || (x.operation  && x.operation.id));
                    });
                }

                scope.getResult = function() {
                    return isValid() ? unflatten(scope.rows[0]) : null;
                };

                scope.getInputType = function(type) {
                    if (type.format == 'number') {
                        return type.format;
                    } else if (propertyTypes[type.format]) {
                        return 'select';
                    } else {
                        return 'text';
                    }
                };

                scope.getSelectOptions = function(type) {
                    return propertyTypes[type.format];
                };

                scope.getOperations = function(row) {
                    var f = {
                        'bool': ['eq', 'neq'],
                        'number': ['eq', 'neq', 'gt', 'gte', 'lt', 'lte']
                    };
                    var u = f[row.type.format];
                    if (u) {
                        return scope.operations.filter(function(x) { return u.indexOf(x.id) != -1; });
                    }

                    return scope.operations;
                };
                scope.types.sort(function(a, b) {
                    return scope.getTypeOrder(a) < scope.getTypeOrder(b)?-1:1;
                });
            }

            function removePrependedDatatype(datatype, r) {
                if (r.content) {
                    r.content.forEach(function(r) {
                        removePrependedDatatype(datatype, r);
                    });
                } else {
                    if (r.lhs.startsWith(datatype + '.')) {
                        r.lhs = r.lhs.substring(datatype.length + 1);
                    }
                }
            }

            scope.$watchGroup(['info', 'datatype'], function() {
                if(scope.info && scope.datatype && !scope.myModel) {
                    setup();
                }
            });

            scope.$watch('getResult()', function(result, oldValue) {
                if (result === oldValue) {
                    return;
                }
                scope.myModel = result;
            }, true);

            scope.$watch('myModel', function(result) {
                if (!scope.haveSetInitialValue || scope.resetInitView) {
                    result = angular.copy(result);
                    if (result) {
                        removePrependedDatatype(scope.datatype.id, result);
                    }
                    setup(result);
                    scope.haveSetInitialValue = true;
                    scope.resetInitView = false;
                }
            });
        }
    };
}]);

directives.factory('showreport', ['$rootScope', 'propertyhelper', 'fileManager', '$filter', 'server', function($rootScope, propertyhelper, fileManager, $filter, server) {
    function getDescendantProp(obj, desc) {
        var arr = desc.split(".");
        while(arr.length && (obj = obj[arr.shift()])) {}
        return obj;
    }

    return {
        createTableConfig: function(data, info) {
            var tableConfig;
            var columns = [];
            var exp = propertyhelper.getExpandedProperties(info, data.datatype);
            var dateProperties = [];
            data.properties.forEach(function(p) {
                if (p == 'groupcount') {
                    p = {id: 'groupcount', name: 'Group count', format: 'number'};
                } else if (p.startsWith('grouppercent_')) {
                    var pid = p;
                    var pname = p.substring(13);
                    p = angular.copy(_.findWhere(exp, {id: pname}));
                    if (!p) {
                        p = {};
                    }
                    p.id = pid;
                    p.format = 'percentage';
                    var name = pname == 'groupcount' ? $filter('translate')('Group count') : propertyhelper.getPropertyName(p);
                    p.name = $filter('translate')('Percentage') + ' ' + name;
                } else {
                    var field = p;
                    p =_.findWhere(exp, {id: p});
                    if(!p) {return columns.push({field: field, title: '', format: ''});}
                }
                var format = p.format;
                if (info.property_types[p.format]) {
                    format = 'translated';
                }
                var d = {
                    field: p.id,
                    title: propertyhelper.getPropertyName(p),
                    format: format
                };

                if (p.format == 'image')  {
                    d.src = function(obj) {
                        var dt = p.parent ? p.parent.joinedproperty.id : data.datatype;
                        return fileManager.fileLinkByObject(getDescendantProp(obj, p.id), 50, dt);
                    };
                }

                columns.push(d);

                if (p.format == 'date' || p.format == 'datetime') {
                    dateProperties.push(p);
                }
            });

            if (dateProperties.length) {
                data.data.forEach(function(x) {
                    dateProperties.forEach(function(d) {
                        x[d.id] = Date.newFull(x[d.id]);
                    });
                });
            }

            var buttons = [];
            if(data.datatype === 'user' && $rootScope.confirmMemberCreate) {
                if(data.properties.indexOf('confirmed') >= 0 || data.name === 'Unconfirmed customers') {
                    buttons.push({
                        title: 'Confirm',
                        visible: function(member) {
                            return member && member.confirmed !== 'yes' && member._user_id;
                        },
                        loading: function(member) {
                            return member && member.__loading;
                        },
                        onClick: function(member) {
                            member.__loading = true;
                            server.post(
                                '/api/member/change',
                                {id: member._user_id, confirmed: true},
                                null,
                                'Information saved',
                                'Failed to save information'
                            ).then(function(response) {
                                member.__loading = false;
                                if(response.success) {
                                    member.confirmed = 'yes';
                                    tableConfig.control.update(false);
                                }
                            });
                        }
                    });
                }
            }

            if(data.datatype === 'user' && data.name === 'Invalid mail') {
                buttons.push({
                    title: 'Unlock',
                    buttonClass: 'btn-danger',
                    onClick: function(member) {
                        server.post2(
                            '/api/mail/unblock',
                            {member_id: member.id},
                            { successAlert: 'Customer unlocked',
                              errorAlert: 'Failed to unlock customer'}
                        ).then(function(response) {
                            if (response.success) {
                                var user = _.findWhere(data.data, {id: member.id});
                                data.data.splice(data.data.indexOf(user), 1);
                                tableConfig.control.update(false);
                            }
                        });
                    }
                });
            }

            tableConfig = {
                getItems: function() {
                    return data.data;
                },
                rowClick: function(row) {
                    if(row?._user_id) {
                        $rootScope.gotoCustomer({id: row._user_id});
                    }
                },
                rowLink: function(row) {
                    if(row?._user_id) {
                        return '/staff#/customer/show/' + row._user_id;
                    }

                    return '';
                },
                getTitle: function() {
                    if (data.name) {
                        return $filter('translate')(data.name);
                    }

                    var dt = _.findWhere(info.datatypes, {id: data.datatype});
                    return $filter('translate')(dt.many).capitalize();
                },
                columns: columns,
                buttons: (buttons && buttons.length)?buttons:null,
                searchDepth: 10
            };

            return tableConfig;

        }
    };
}]);

directives.directive('showreport', ['$rootScope', '$filter', 'propertyhelper', 'server', 'util', 'fileManager', 'showreport', '$modal', '$q', 'pubsub', '$location', '$timeout', 'dropdownmodal', function($rootScope, $filter, propertyhelper, server, util, fileManager, showreport, $modal, $q, pubsub, $location, $timeout, dropdownmodal) {
    return {
        restrict: 'E',
        templateUrl: 'views/report.html',
        scope: {
            info: '=',
            reportRequest: '=?',
            reportData: '=?',
            reportId: '=?',
            option: '=?'
        },
        link: function(scope, element) {
            var option = scope.option || {};
            let changeLoading = false;

            scope.getKeyValueStyle = function() {
                var style = {
                    color: scope.keyvalueData.color
                };

                if (scope.option && scope.option.keyvaluecenter) {
                    style.position = 'absolute';
                    style.left = '50%';
                    style.top = '50%';
                    style.transform = 'translate(-50%, -50%)';
                }

                return style;
            };

            function createTableConfig(data) {
                scope.tableConfig = showreport.createTableConfig(data, scope.info);

                if(option.rowClick && !scope.tableConfig.rowClick) {
                    scope.tableConfig.rowClick = option.rowClick;
                }

                scope.tableConfig.countSuffix = function() {
                    var count = scope.tableConfig.control.getFilteredItems().length;
                    var dt = _.findWhere(scope.info.datatypes, {id: data.datatype});
                    if (data.groupproperty) {
                        dt = {one: 'row', many: 'rows'};
                    }
                    return $filter('translate')(count == 1 ? dt.one : dt.many);
                };

                scope.tableConfig.getSubTitle = function() {
                    return scope.reportSubtitle;
                };

                function loadUsers(fields) {
                    return $q.promise(function(resolve, reject) {
                        var report = scope.reportId?{report_id: scope.reportId}:scope.reportRequest;
                        server.post2('/api/stats/generic/user/get', {
                            report: report,
                            fields: fields
                        }).then(function(response) {
                            response.forEach(function(m) {m.isMember = true;});
                            resolve(response);
                        }, reject);
                    });
                }

                const exp = propertyhelper.getExpandedProperties(scope.info, data.datatype);
                let customerColumns = {};
                data.properties.forEach(prop => {
                    prop = _.findWhere(exp, { id: prop });
                    if(prop?.parent?.joinedproperty?.id == 'user') {
                        const p = prop.parent;
                        if(customerColumns[p.id]) return;
                        let name = p.name;
                        if(!Array.isArray(name)) name = [name];
                        name = name.map(n => $filter('translate')(n)).join(' > ')
                        customerColumns[p.id] = { id: p.id, name };
                    }
                });
                customerColumns = Object.values(customerColumns);

                function showSendMailingButton() {
                    return data.datatype == 'user' || customerColumns.length > 0;
                }

                scope.tableConfig.searchButtons = [
                    {
                        title: 'Send mailing',
                        onClick: function(tableConfig, event) {
                            let filteredRows = scope.tableConfig.control.getFilteredItems();

                            function openMailing(selectedProp) {
                                let uniqId = {};
                                if(selectedProp) {
                                    filteredRows.forEach(obj => {
                                        let keys = selectedProp.id.split('.');
                                        while(keys.length) {
                                            obj = obj[keys.shift()];
                                        }
                                        if (obj?.id) {
                                            let obj_ids = obj.id;
                                            if (!Array.isArray(obj_ids)) obj_ids = [obj_ids];
                                            obj_ids.forEach(oid => uniqId[oid] = oid);
                                        }
                                    });
                                } else if(data.datatype == 'user') filteredRows.forEach(u => uniqId[u.id] = u.id);
                                else filteredRows.forEach(row => uniqId[row._user_id] = row._user_id);
                                let filterdUsers = Object.values(uniqId).map(id => ({id}));
                                pubsub.publish('newmailingdata', {
                                    isNewsOrAdvertising: false,
                                    sendOption: 'mail',
                                    receivers: filterdUsers,
                                    options: { 'callCloseOnSuccess': true, 'modalMode': false, noRedirect: true }
                                });
                                $modal.open({
                                    templateUrl: 'views/mailingnew.html',
                                    windowClass: 'huge-modal-window',
                                    controller: 'NewMailingCtrl'
                                });
                            }

                            if(customerColumns.length > 1) {
                                return dropdownmodal({
                                    target: event.currentTarget,
                                    items: customerColumns
                                }).then(selectedProp => {
                                    openMailing(selectedProp);
                                });
                            } else openMailing();
                        },
                        visible: function() {return $rootScope.hasPermission('Mailing handling') && showSendMailingButton();}
                    },
                    {
                        title: 'Download as Excel', onClick: function() {
                            scope.tableConfig.control.exportTo('excel').then(function(blob) {
                                util.download(scope.tableConfig.getTitle() + '.xlsx', null, null, blob);
                            });
                        }
                    },
                    {
                        title: 'Print',
                        onClick: function () {
                            scope.tableConfig.control.print(scope.tableConfig.getTitle());
                        }
                    },
                    {
                        title: 'Sync with MailChimp',
                        onClick: function() {
                            loadUsers(['mail', 'firstname', 'lastname']).then(function(response) {
                                $modal.open({
                                    templateUrl: 'views/mailchimp.html',
                                    controller: 'MailChimpCtrl',
                                    resolve: {
                                        items: function() {
                                            return response;
                                        }
                                    }
                                });
                            });
                        },
                        visible: function() { return $rootScope.hasPermission('Sync with MailChimp');}
                    },
                    {
                        title: 'Reload', onClick: scope.reload, showOnEmpty: true,
                        visible: function() { return option.showReload !== false }
                    },
                    {
                        title: 'Change',
                        buttonClass: 'btn-warning',
                        showOnEmpty: true,
                        visible: function() { return option.showChange && scope.reportId && $rootScope.hasPermission('Create reports'); },
                        loading: () => changeLoading,
                        onClick: scope.change
                    }
                ];

                if(option.hideHeader) {
                    scope.tableConfig.hideSearchCount = true;
                    scope.tableConfig.hideSearch = true;
                    $timeout(function() {
                        element.find('customertable .row').hide();
                    });
                }
                if (option.showMailing) {
                    scope.tableConfig.showMailing = true;
                }
                if (option.giveFocus) {
                    scope.tableConfig.giveFocus = option.giveFocus;
                }
                if (option.hideSearchWhenFewerThan) {
                    scope.tableConfig.hideSearchWhenFewerThan = option.hideSearchWhenFewerThan;
                }
            }

            function showReport(data) {
                if (data.reporttype == 'list') {
                    createTableConfig(data);
                } else if (data.reporttype == 'map') {
                    scope.mapData = data.data;
                } else if (data.reporttype == 'keyvalue')  {
                    scope.keyvalueData = data;
                    if (data.resulttypeproperty) {
                        scope.keyvalueData.format = _.findWhere(scope.info.properties[data.datatype], {id: data.resulttypeproperty}).format;
                    }
                } else {
                    scope.diagramData = data;
                }

                if(!option.hideHeader) {
                    scope.reportName = data.name;
                    scope.from = data.from;
                    scope.to = data.to;
                    scope.reportSubtitle = data.subtitle;
                }
            }

            function getReport(id) {
                scope.loadingStatus = {loading: true};
                server.post('/api/stats/generic', {report_id: id, include_id: !!option.showMailing}).then(function(result) {
                    if (result.success) {
                        showReport(result.data);
                    } else {
                        scope.error = true;
                    }
                    scope.loadingStatus.loading = false;
                });
            }

            function reset() {
                scope.keyvalueData = null;
                scope.tableConfig = null;
                scope.diagramData = null;
                scope.mapData = null;
                scope.error = null;
            }

            scope.reload = function() {
                if (scope.reportId && scope.info) {
                    reset();
                    getReport(scope.reportId);
                } else if (scope.reportData && scope.info) {
                    reset();
                    showReport(scope.reportData);
                }
            };

            scope.change = function() {
                $modal.open({
                    templateUrl: 'views/changemodal.html',
                    controller: 'ReportChangeModalCtrl',
                    windowClass: 'huge-modal-window',
                    resolve: {
                        report: function() {
                            changeLoading = true;
                            return server.get('/api/stats/generic/reports/get', {id: scope.reportId }).then(function(response) {
                                changeLoading = false;
                                return response;
                            });
                        }
                    }
                }).result.then(function() {
                    scope.reload();
                });
            };

            scope.$watch('reportData', function() {
                if (scope.reportData && scope.info) {
                    reset();
                    showReport(scope.reportData);
                } else if (scope.info && !scope.reportData && (scope.keyvalueData || scope.tableConfig || scope.diagramData)) {
                    reset();
                }
            });

            scope.$watch('reportId', function() {
                if (scope.reportId && scope.info) {
                    reset();
                    getReport(scope.reportId);
                }
            });
        }
    };
}]);

directives.directive('filesearch', ['$rootScope', '$location', 'util', function($rootScope, $location, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/filesearch.html',
        scope: {
            config: '='
        },
        link: function(scope, element) {
            scope.config.searchFilter = function(f) {
                return !scope.search.cat || scope.search.cat.origin_type == f.origin_type;
            };

            scope.getFileCategories = function() {
                return $rootScope.fileCategories;
            };

            scope.categoryChanged = function() {
                scope.config.control.update();
            };

            scope.config.getSaveStateName = function() {
                return util.getSaveStateName($location.path(), element);
            };

            scope.search = { cat: scope.config.searchMethod };
        }
    };
}]);

directives.directive('mailingsearch', ['$rootScope', '$filter', '$location', 'util', function($rootScope, $filter, $location, util) {
    return {
        restrict: 'E',
        templateUrl: 'views/mailingsearch.html',
        scope: {
            config: '='
        },
        link: function(scope, element) {
            scope.isMailingTemplate = function() {
                return scope.config.countSuffixList.indexOf('template') > -1;
            };

            scope.isMailingAdminPage = function() {
                return !!scope.config.isMailingAdminPage;
            };

            scope.config.searchFilter = function(r) {
                if ((!scope.sendOption && !scope.config.searchText) || (!scope.config.searchText && (scope.sendOption.id === 'noSendingOptionChosen' || scope.sendOption.id === 'noMailingTypeChosen'))) { return true; }

                var selectOption = !scope.isMailingAdminPage() ? r.type : r.sendAs;
                var searchText = scope.config.searchText ? scope.config.searchText.toLowerCase() : null;
                var checkText = !searchText;
                var checkSelect = !scope.sendOption;
                if (searchText) {
                    var s = $filter('translate')(_.findWhere(scope.sendOptions, {id: selectOption})?.name).toLowerCase();
                    var n = $filter('translate')(r.name ? r.name : r.headline).toLowerCase();
                    checkText = s.includes(searchText) || n.includes(searchText);
                }
                if (scope.sendOption) {
                    checkSelect = ['noSendingOptionChosen', 'noMailingTypeChosen', 'noMailingCategoryChosen'].indexOf(scope.sendOption.id) > -1 || selectOption == scope.sendOption.id;
                }
                return checkText && checkSelect;
            };

            scope.config.customSearch = function() { return true; }; // In case it goes to "else" statement in customertable.js after searchFilter

            if (scope.isMailingTemplate()) {
                scope.sendOptions = [
                    {id: 'mail', name: 'Mail'},
                    {id: 'sms', name: 'SMS'},
                    {id: 'survey', name: 'Survey'},
                    {id: 'news', name: 'News'},
                    {id: 'push', name: 'Push notification'},
                    {id: 'offer', name: 'Offer'},
                    {id: 'noMailingTypeChosen', name: 'No mailing type chosen'},
                    ...$rootScope.getMailingHandlerSendAsOptions()
                ];
            } else if (!scope.isMailingAdminPage()) {
                scope.sendOptions = [
                    {id: 'mail', name: 'Mail'},
                    {id: 'sms', name: 'SMS'},
                    {id: 'survey', name: 'Survey'},
                    {id: 'news', name: 'News'},
                    {id: 'push', name: 'Push notification'},
                    {id: 'noMailingCategoryChosen', name: 'No mailing category chosen'},
                    ...$rootScope.getMailingHandlerSendAsOptions()
                ];
            } else {
                scope.sendOptions = [
                    {id: 'emailAndSMS', name: 'Both mail and SMS'},
                    {id: 'emailOnly', name: 'Only email'},
                    {id: 'SMSOnly', name: 'Only SMS'},
                    {id: 'emailFirst', name: 'First email and second SMS'},
                    {id: 'SMSFirst', name: 'First SMS and second email' },
                    {id: 'push', name: 'Only push'},
                    {id: 'noMailing', name: 'No mailing'},
                    {id: 'noSendingOptionChosen', name: 'No sending option chosen'},
                    ...$rootScope.getMailingHandlerSendAsOptions()
                ];
            }

            scope.sendOptionChanged = function() {
                scope.config.control?.update();
            };
            $rootScope.waitFor(['mailinghandlers']).then(scope.sendOptionChanged);

            scope.config.getSaveStateName = function() {
                return util.getSaveStateName($location.path(), element);
            };
        }
    };
}]);
